module.exports = __webpack_public_path__ + "img/info-headphones.e84dae5f.svg";